const settingsPageUserInfoSectionCopy = {
  errorMessageUpdateAuthenticatedUserPasswordFailed:
    'Current password is not valid.',
  sectionTitle: 'User Info',
  successMessageUpdatedAuthenticatedUserPassword:
    'Your password has successfully been changed.'
};

export default settingsPageUserInfoSectionCopy;
